import { useState } from 'react';
import { Link } from 'react-router';
import { copyText, roomLink, whatsappLink } from '../../components/Chrome';
import { usePrefs } from '../../components/Prefs';
import { Sheet } from '../../components/Sheet';
import { SuggestForm } from '../../components/SuggestForm';
import type { RoomApi } from '../../lib/useRoom';

export function RoomMenu({ room, onClose, onLeft }: { room: RoomApi; onClose: () => void; onLeft: () => void }) {
  const view = room.view!;
  const { showGloss, setShowGloss, showDevanagari, setShowDevanagari, toast } = usePrefs();
  const [suggest, setSuggest] = useState(false);
  const isHost = view.me?.id === view.hostId;
  const midRound = ['choosing', 'writing', 'submitting', 'judging'].includes(view.phase);
  const inGame = view.phase !== 'lobby' && view.phase !== 'game_over';
  const invite = `Come play CompleteMasti with us! Room code ${view.code}: ${roomLink(view.code)}`;

  async function run(event: 'round:skip' | 'game:end', confirmText: string) {
    if (!window.confirm(confirmText)) return;
    const err = await room.act(event, {});
    if (err) toast(err, 'error');
    else onClose();
  }

  if (suggest) {
    return (
      <Sheet title="Suggest a card" onClose={onClose}>
        <SuggestForm roomCode={view.code} onDone={onClose} />
      </Sheet>
    );
  }

  return (
    <Sheet title={`Room ${view.code}`} onClose={onClose}>
      <nav className="menu-list">
        <a href={whatsappLink(invite)} target="_blank" rel="noreferrer">
          💬 Invite on WhatsApp
        </a>
        <button
          type="button"
          onClick={async () => {
            if (await copyText(roomLink(view.code))) toast('Invite link copied.');
          }}
        >
          🔗 Copy invite link
        </button>
        <a href={`/tv/${view.code}`} target="_blank" rel="noreferrer">
          📺 Open TV mode <span className="muted small">for a laptop or TV everyone can see</span>
        </a>
        <button type="button" onClick={() => setShowGloss(!showGloss)}>
          🔤 Translations under Hindi words: <strong>{showGloss ? 'On' : 'Off'}</strong>
        </button>
        <button type="button" onClick={() => setShowDevanagari(!showDevanagari)}>
          अ Hindi lines in Devanagari too: <strong>{showDevanagari ? 'On' : 'Off'}</strong>
        </button>
        <button type="button" onClick={() => setSuggest(true)}>
          ✍️ Suggest a card for the deck
        </button>
        <Link to="/how-to-play" target="_blank">
          ❓ How to play
        </Link>
        {isHost && midRound && (
          <button type="button" onClick={() => run('round:skip', 'Skip this round? Played cards go back to their owners.')}>
            ⏭️ Skip this round
          </button>
        )}
        {isHost && inGame && (
          <button type="button" onClick={() => run('game:end', 'End the game now? Whoever is ahead wins.')}>
            🏁 End game now
          </button>
        )}
        <button
          type="button"
          className="danger"
          onClick={async () => {
            if (!window.confirm('Leave this room? Your cards and score go with you.')) return;
            await room.leave();
            onLeft();
          }}
        >
          🚪 Leave room
        </button>
      </nav>
    </Sheet>
  );
}
